import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { setUserLoading, logoutUser } from "redux/actions/authActions";


import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import jwt_decode from "jwt-decode";
import setAuthToken from "utils/setAuthToken";

const initialState = {};

const middleware = [thunk];

const persistConfig = {
  transforms: [
    encryptTransform({
      secretKey: 'g2234hui23$"37hqw',
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
  key: 'root',
  storage,
  blacklist: ['user', 'category', 'lead', ]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()) ||
    compose
  )
);

const persistor = persistStore(store);

const syncWithServer = async (store) => {
  const authState = store.getState().auth;
  if (authState && authState.isAuthenticated) {

    setAuthToken(authState.token);
    const decoded = jwt_decode(authState.token);

    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime || !authState.rememberMe) {
      store.dispatch(logoutUser());
      window.location.href = "./login";
    }
    //Verify with server just in case
    store.dispatch(setUserLoading());
  }
};

export { store, persistor, syncWithServer };